import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ColumnKey } from '../../models';

@Component({
  selector: 'th[app-sortable-header]',
  standalone: true,
  imports: [],
  template: `
    <div
      class="header-content"
      [class.align-right]="align === 'right'"
      [class.align-center]="align === 'center'"
      [class.align-left]="align === 'left'"
      >
      {{ formattedLabel }}
      <span class="sort-icon" [class.active]="isActive">
        @if (isActive && sortConfig?.direction === 'desc') {
          <i class="material-symbols-rounded">arrow_downward</i>
        }
        @if (isActive && sortConfig?.direction === 'asc') {
          <i class="material-symbols-rounded">arrow_upward</i>
        }
        @if (!isActive) {
          <i class="material-symbols-rounded">unfold_more</i>
        }
      </span>
    </div>
    `,
  styleUrl: './sortable-header.component.scss',
  host: {
    '(click)': 'onSort()',
    '[title]': 'titleText'
  }
})
export class SortableHeaderComponent {
    @Input() label = '';
    @Input() columnKey!: ColumnKey;
    @Input() sortConfig: { key: ColumnKey; direction: 'asc' | 'desc' } | null = null;
    @Input() align: 'left' | 'right' | 'center' = 'left';
    /**
     * Optional long-form text for the native header tooltip. When set, the
     * hover title reads "Sort by {tooltip}"; otherwise it falls back to the
     * visible (abbreviated) label. Used to expand "UAN 1" → "Utility Account
     * Number 1" on hover without cluttering the visible header.
     */
    @Input() tooltip: string | null = null;
    @Output() sort = new EventEmitter<ColumnKey>();

    get isActive() { return this.sortConfig?.key === this.columnKey; }

    get titleText(): string {
        return `Sort by ${this.tooltip || this.formattedLabel}`;
    }

    get formattedLabel(): string {
        // Callers now pre-format labels via formatColumnLabel, so these special
        // cases only kick in if a raw column key slips through.
        if (this.label === 'utilityAccountNumber') return 'UAN 1';
        if (this.label === 'utilityAccountNumber2') return 'UAN 2';
        if (this.label === 'legalEntity') return 'Customer';
        if (this.label === 'startDate' || this.label === 'billingPeriodStart') return 'Start Date';
        if (this.label === 'endDate' || this.label === 'billingPeriodEnd') return 'End Date';
        // Convert camelCase to spaced words (e.g., legalEntity -> Legal Entity)
        return this.label
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            .replace(/^./, str => str.toUpperCase());
    }

    onSort() { this.sort.emit(this.columnKey); }
}
